module.exports = __webpack_public_path__ + "static/media/acceptResolution.9c9cc57c.svg";